<template>
  <div id="form-slideshow-add">
    <BaseModal
      :title="getTitleModalChooseLayer"
      :show.sync="isShow"
      size="xl"
      :closeOnBackdrop="false"
    >
      <template v-slot:body-wrapper>
        <div class="modal-body" style="max-height: 80vh; overflow: auto">
          <template v-if="typeLayer === typeChooseLayer.VIDEO">
            <CRow class="mt-3 px-2">
              <template v-if="itemsLayerChoose.length <= 0">
                Danh sách trống!
              </template>
              <template v-else v-for="itemChoose of itemsLayerChoose">
                <CCol
                  xs="12"
                  md="12"
                  lg="2"
                  xl="2"
                  class="mb-4"
                  @click="selectedLayer(itemChoose)"
                >
                  <div class="layout-insert-item-column">
                    <div
                      class="layout-insert-item-type"
                      :class="{ selected: activeElement == itemChoose.id }"
                    >
                      <img
                        :src="itemChoose.urlThumbnail"
                        alt="Không tìm thấy"
                      />
                    </div>
                    <span
                      class="layout-insert-item-label"
                      v-c-tooltip="itemChoose.title"
                    >
                      {{ itemChoose.title }}
                    </span>
                  </div>
                </CCol>
              </template>
            </CRow>
          </template>

          <template
            v-else-if="
              typeLayer === typeChooseLayer.IMAGE ||
              typeLayer === typeChooseLayer.STREAM_VTV
              || typeLayer == typeChooseLayer.WIDGET
            "
          >
            <CRow class="mt-3 px-2">
              <template v-if="itemsLayerChoose.length <= 0">
                Danh sách trống!
              </template>
              <template v-else v-for="itemChoose of itemsLayerChoose">
                <CCol
                  xs="12"
                  md="12"
                  lg="2"
                  xl="2"
                  class="mb-4"
                  @click="selectedLayer(itemChoose)"
                >
                  <div class="layout-insert-item-column">
                    <div
                      class="layout-insert-item-type"
                      :class="{ selected: activeElement == itemChoose.id }"
                    >
                      <img
                        :src="itemChoose.urlThumbnail"
                        :style="
                          typeLayer === typeChooseLayer.STREAM_VTV
                            ? 'object-fit:contain;'
                            : 'object-fit:cover;'
                        "
                        alt="Không tìm thấy"
                      />
                    </div>
                    <span
                      class="layout-insert-item-label"
                      v-c-tooltip="itemChoose.title"
                    >
                      {{ itemChoose.title }}
                    </span>
                  </div>
                </CCol>
              </template>
            </CRow>
          </template>

          <template
            v-else-if="
              typeLayer === typeChooseLayer.TEXT ||
              typeLayer === typeChooseLayer.RSS ||
              typeLayer === typeChooseLayer.DOCUMENT ||
              typeLayer === typeChooseLayer.DOCUMENT
            "
          >
            <CRow class="mt-3 px-2">
              <CCol sm="12" md="12" xl="12">
                <CDataTable
                  :items="itemsLayerChoose"
                  :fields="chooseLayerTextTable.options.fields"
                  :sorterValue="{ column: null, asc: 'true' }"
                  @row-clicked="clickRowChooseLayerTextRssTable"
                >
                  <template #title="{ item }">
                    <td>{{ item.title }}</td>
                  </template>
                  <template #isRun="{ item }">
                    <td>
                      <span
                        v-if="item.isRun === true"
                        class="badge badge-secondary"
                        >Chữ chạy</span
                      >
                      <span v-else class="badge badge-secondary"
                        >Chữ thường</span
                      >
                    </td>
                  </template>
                  <template #type="{ item }">
                    <td>
                      <span
                        v-if="item.type === 4"
                        class="badge badge-secondary"
                        >{{
                          item.url
                            .substring(
                              item.url.lastIndexOf(".") + 1,
                              item.url.length
                            )
                            .toUpperCase()
                        }}</span
                      >
                    </td>
                  </template>
                  <template #action="{ item }">
                    <td class="action-btn-group">
                      <CInputRadio
                        type="radio"
                        addInputClasses="override-custom"
                        custom
                        :value="item.id"
                        name="test"
                        :checked="item.checked"
                      />
                    </td>
                  </template>
                  <template slot="no-items-view">
                    <span style="color: #969696">Danh sách trống!</span>
                  </template>
                  <template slot="loading">
                    <BaseLoading :loading="loading" />
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
          </template>

          <template v-else-if="typeLayer === typeChooseLayer.PLAY_LIST">
            <CRow class="mt-3 px-2">
              <CCol sm="12" md="12" xl="12">
                <CDataTable
                  :items="itemsPlayList"
                  :fields="itemsPlayListTable.options.fields"
                  :sorterValue="{ column: null, asc: 'true' }"
                  @row-clicked="clickRowPlayListTable"
                >
                  <template #type="{ item }">
                    <td>
                      <span
                        v-if="item.type == typePlayList.TEXT_RUN"
                        class="badge badge-secondary"
                        >Chữ chạy</span
                      >
                      <span
                        v-else-if="item.type == typePlayList.TEXT_NORMAL"
                        class="badge badge-secondary"
                        >Văn bản</span
                      >
                      <span
                        v-else-if="item.type == typePlayList.IMAGE"
                        class="badge badge-secondary"
                        >Hình ảnh</span
                      >
                      <span
                        v-else-if="item.type == typePlayList.VIDEO"
                        class="badge badge-secondary"
                        >Video</span
                      >
                      <span
                        v-else-if="item.type == typePlayList.DOCUMENT"
                        class="badge badge-secondary"
                        >Tài liệu</span
                      >
                    </td>
                  </template>
                  <template #action="{ item }">
                    <td class="action-btn-group">
                      <CInputRadio
                        type="radio"
                        addInputClasses="override-custom"
                        custom
                        :value="item.id"
                        name="test"
                        :checked="item.checked"
                      />
                    </td>
                  </template>
                  <template slot="no-items-view">
                    <span style="color: #969696">Danh sách trống!</span>
                  </template>
                  <template slot="loading">
                    <BaseLoading :loading="loading" />
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
          </template>

          <template v-else-if="typeLayer === typeChooseLayer.YOUTUBE">
            <CRow class="mb-3 px-2">
              <CCol xs="12" md="12" lg="12">
                <BaseInput
                  :options="urlYoutubeInput.options"
                  :data="urlYoutubeInput.data"
                  @keyup.enter="submitSelectedLayer()"
                  class="input-wrapper"
                />
              </CCol>
            </CRow>
          </template>
        </div>
      </template>
      <template v-slot:footer>
        <div slot="footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="isShow = false"
          >
            <i class="fa fa-close"></i> Hủy bỏ</button
          >&nbsp;
          <button
            type="button"
            class="btn btn-primary"
            :disabled="disableButton"
            @click="submitSelectedLayer()"
          >
            <i class="fa fa-check"></i> Chọn
          </button>
        </div>
      </template>
    </BaseModal>
    <BaseFormLoading
      :loading="loading.value"
      style="z-index: 99999"
    ></BaseFormLoading>
  </div>
</template>
<script>
import { ActionEditor, TypeChooseLayer, TypePlayList } from "../../constant";
import BaseModal from "@/views/base/BaseModal";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import BaseInput from "@/views/base/BaseInput";

export default {
  name: "SlideShowModal",
  components: { BaseInput, BaseModal, BaseFormLoading },
  props: ["typeLayer", "items"],
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data: function () {
    let that = this;
    return {
      itemsLayerChoose: [],
      itemsPlayList: [],
      loading: { value: false },
      actionEditor: ActionEditor,
      typeChooseLayer: TypeChooseLayer,
      typePlayList: TypePlayList,
      chooseLayerTextTable: {
        options: {
          fields: [],
          slots: [],
        },
      },
      itemsPlayListTable: {
        options: {
          fields: [
            { key: "name", label: "Tên danh sách phát" },
            { key: "type", label: "Loại danh sách phát" },
            { key: "action", label: "Thao tác" },
          ],
          slots: ["index", "type", "action"],
        },
      },
      activeElement: null,
      isShow: false,
      disableButton: true,
      itemLayer: null,
      urlYoutubeInput: {
        options: {
          placeholder: "Đường dẫn Youtube",
          label: "Đường dẫn Youtube",
          addInputClasses: "youtubeInput",
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitSelectedLayer();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.urlYoutubeInput.data.model;
              let regex_youtube =
                /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Đường dẫn Youtube không được để trống";
              } else if (regex_youtube.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Sai định dạng đường dẫn Youtube";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
    };
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    getTitleModalChooseLayer() {
      if (this.typeLayer === this.typeChooseLayer.IMAGE) {
        return "Hình ảnh";
      } else if (this.typeLayer === this.typeChooseLayer.VIDEO) {
        return "Video";
      } else if (this.typeLayer === this.typeChooseLayer.TEXT) {
        return "Văn bản";
      } else if (this.typeLayer === this.typeChooseLayer.PLAY_LIST) {
        return "Danh sách phát";
      } else if (this.typeLayer === this.typeChooseLayer.YOUTUBE) {
        return "Youtube";
      } else if (this.typeLayer === this.typeChooseLayer.RSS) {
        return "RSS";
      } else if (this.typeLayer === this.typeChooseLayer.DOCUMENT) {
        return "Tài liệu";
      } else if (this.typeLayer === this.typeChooseLayer.STREAM_VTV) {
        return "Kênh trực tuyến";
      } else if (this.typeLayer === this.typeChooseLayer.WIDGET) {
        return "Tiện ích";
      }
    },
  },
  created() {},
  mounted() {
    let that = this;
    if (this.typeLayer === this.typeChooseLayer.YOUTUBE) {
      this.isShow = true;
      setTimeout(() => {
        that.$el.querySelector(".youtubeInput").focus();
      }, 100);
    } else if (this.typeLayer === this.typeChooseLayer.PLAY_LIST) {
      this.loadDataPlayList();
    } else {
      this.loadDataFile();
    }
  },
  methods: {
    loadDataFile() {
      var _type = this.typeChooseLayer.VIDEO;
      if (this.typeLayer === this.typeChooseLayer.TEXT) {
        _type = 0;
      } else if (this.typeLayer === this.typeChooseLayer.IMAGE) {
        _type = 1;
      } else if (this.typeLayer === this.typeChooseLayer.RSS) {
        _type = 3;
      } else if (this.typeLayer === this.typeChooseLayer.DOCUMENT) {
        _type = 4;
      } else if (this.typeLayer === this.typeChooseLayer.STREAM_VTV) {
        _type = 5;
      } else if (this.typeLayer === this.typeChooseLayer.WIDGET) {
        _type = 6;
      }
      let that = this;
      if (_type == 6) {
        that.loading.value = true;
        that.$helper.loadDataSource({
          url: "/widget/load-by-org-id",
          ignoreDefaultData: true,
          isJsonContentType: false,
          successCallback: function (response) {
            if (that.$helper.validResponse(that.$router, response.data)) {   
              that.itemsLayerChoose = response.data.data;  
              that.isShow = true;
              that.loading.value = false;
            }
          },
          errorCallback: function (error) {
            that.loading.value = false;
            that.$helper.handleError(that.$router, error);
          },
        });
      } else {
        that.loading.value = true;
        that.$helper.loadDataSource({
          url: "/screen-file/findAllByTypeForSlideShow",
          dataSubmit: function () {
            return {
              type: _type,
            };
          },
          ignoreDefaultData: true,
          isJsonContentType: false,
          successCallback: function (response) {
            if (that.$helper.validResponse(that.$router, response.data)) {
              if (
                that.typeLayer === that.typeChooseLayer.TEXT ||
                that.typeLayer === that.typeChooseLayer.RSS ||
                that.typeLayer === that.typeChooseLayer.DOCUMENT
              ) {
                response.data.data.map((each) => {
                  each.checked = false;
                  that.itemsLayerChoose.push(each);
                });
                if (that.typeLayer === that.typeChooseLayer.TEXT) {
                  that.chooseLayerTextTable.options.fields = [
                    {
                      key: "title",
                      label: "Tên bản tin",
                      _style: "width: 10%;",
                    },
                    {
                      key: "content",
                      label: "Nội dung",
                      _style: "width: 70%;",
                    },
                    { key: "isRun", label: "Loại bản tin" },
                    { key: "action", label: "Thao tác" },
                  ];
                  that.chooseLayerTextTable.options.slots = [
                    "index",
                    "isRun",
                    "title",
                    "action",
                  ];
                } else if (that.typeLayer === that.typeChooseLayer.RSS) {
                  that.chooseLayerTextTable.options.fields = [
                    { key: "title", label: "Tên bản tin" },
                    { key: "description", label: "Mô tả bản tin" },
                    { key: "url", label: "Đường dẫn" },
                    { key: "action", label: "Thao tác" },
                  ];
                  that.chooseLayerTextTable.options.slots = [
                    "index",
                    "title",
                    "action",
                  ];
                } else if (that.typeLayer === that.typeChooseLayer.DOCUMENT) {
                  that.chooseLayerTextTable.options.fields = [
                    {
                      key: "title",
                      label: "Tên bản tin",
                      _style: "width: 20%;",
                    },
                    { key: "description", label: "Nội dung" },
                    { key: "type", label: "Loại bản tin" },
                    { key: "action", label: "Thao tác" },
                  ];
                  that.chooseLayerTextTable.options.slots = [
                    "index",
                    "title",
                    "type",
                    "action",
                  ];
                }
              } else {
                that.itemsLayerChoose = response.data.data;
              }
              that.isShow = true;
              that.loading.value = false;
            }
          },
          errorCallback: function (error) {
            that.loading.value = false;
            that.$helper.handleError(that.$router, error);
          },
        });
      }
    },
    loadDataPlayList() {
      let that = this;
      this.loading.value = true;
      this.$helper.loadDataSource({
        url: "/play-list/listPlayListByType",
        dataSubmit: function () {
          return {
            type: -1,
          };
        },
        ignoreDefaultData: true,
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            response.data.data.map((each) => {
              each.checked = false;
              that.itemsPlayList.push(each);
            });
            that.isShow = true;
            that.loading.value = false;
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    loadDataDetailPlayList(_id) {
      return new Promise((resolve) => {
        let that = this;
        this.loading.value = true;
        this.$helper.loadDataSource({
          url: "/play-list/find-by-id",
          dataSubmit: function () {
            return {
              id: _id,
            };
          },
          ignoreDefaultData: true,
          isJsonContentType: false,
          successCallback: function (response) {
            if (that.$helper.validResponse(that.$router, response.data)) {
              resolve(response.data.data);
              that.loading.value = false;
            }
          },
          errorCallback: function (error) {
            that.loading.value = false;
            that.$helper.handleError(that.$router, error);
          },
        });
      });
    },
    loadDataRSS(_url) {
      return new Promise((resolve) => {
        let that = this;
        this.$helper.loadDataSource({
          url: "/screen-file/getRss",
          dataSubmit: function () {
            return {
              url: _url,
            };
          },
          ignoreDefaultData: true,
          isJsonContentType: false,
          successCallback: function (response) {
            if (that.$helper.validResponse(that.$router, response.data)) {
              resolve(response.data.data);
            }
          },
          errorCallback: function (error) {
            that.loading.value = false;
            that.showErrorMsg({ message: "Lỗi đọc RSS" });
            // that.$helper.handleError(that.$router, error);
          },
        });
      });
    },
    loadDataWidget(itemLayer) {
      return itemLayer
    },
    selectedLayer(value) {
      this.activeElement = value.id;
      this.itemLayer = value;
      this.disableButton = false;
    },
    clickRowChooseLayerTextRssTable(...args) {
      this.disableButton = false;
      this.itemsLayerChoose.map((item, index) => {
        if (index === args[1]) {
          item.checked = true;
          this.itemLayer = item;
        } else {
          item.checked = false;
        }
      });
    },
    clickRowPlayListTable(...args) {
      this.disableButton = false;
      this.itemsPlayList.map((item, index) => {
        if (index === args[1]) {
          item.checked = true;
          this.itemLayer = item;
        } else {
          item.checked = false;
        }
      });
    },
    async submitSelectedLayer() {
      var dataItem = await this.asyncDataItem();
      this.isShow = false;
      if(dataItem) {
        this.$emit("item:selected", dataItem);
      }
    },
    async asyncDataItem() {
      switch (this.typeLayer) {
        case this.typeChooseLayer.TEXT: {
          this.itemLayer.typeLayer = this.typeChooseLayer.TEXT;
          break;
        }
        case this.typeChooseLayer.IMAGE: {
          this.itemLayer.typeLayer = this.typeChooseLayer.IMAGE;
          break;
        }
        case this.typeChooseLayer.VIDEO: {
          this.itemLayer.typeLayer = this.typeChooseLayer.VIDEO;
          break;
        }
        case this.typeChooseLayer.PLAY_LIST: {
          var isExitsVideo = false;
          console.log(this.itemLayer)
          if (this.itemLayer.type === TypePlayList.VIDEO) {
            for (var i = 0; i < this.items.length; i++) {
              var data = this.items[i].extractData;
              if (
                data.typeLayer === this.typeChooseLayer.YOUTUBE ||
                data.typeLayer === this.typeChooseLayer.VIDEO ||
                data.typeLayer === this.typeChooseLayer.STREAM_VTV ||
                (data.typeLayer === this.typeChooseLayer.PLAY_LIST &&
                  data.type === TypePlayList.VIDEO)
              ) {
                isExitsVideo = true;
                break;
              }
            }
          }
          if (isExitsVideo) {
            this.showWarningMsg({
              message:
                "Bạn không thể có nhiều hơn một video trong một trình diễn!",
            });
            return
          } else {
            var playlistDetail = await this.loadDataDetailPlayList(
              this.itemLayer.id
            );
            this.itemLayer = playlistDetail;
            this.itemLayer.typeLayer = this.typeChooseLayer.PLAY_LIST;
          }
          break;
        }
        case this.typeChooseLayer.YOUTUBE: {
          if (!this.urlYoutubeInput.data.validator.valid()) {
            return;
          } else {
            this.itemLayer.typeLayer = this.typeChooseLayer.YOUTUBE;
          }
          break;
        }
        case this.typeChooseLayer.RSS: {
          var dataRss = await this.loadDataRSS(this.itemLayer.url);
          this.itemLayer.itemRss = dataRss;
          this.itemLayer.typeLayer = this.typeChooseLayer.RSS;
          break;
        }
        case this.typeChooseLayer.DOCUMENT: {
          this.itemLayer.typeLayer = this.typeChooseLayer.DOCUMENT;
          break;
        }
        case this.typeChooseLayer.STREAM_VTV: {
          this.itemLayer.typeLayer = this.typeChooseLayer.STREAM_VTV;
          break;
        }
        case this.typeChooseLayer.WIDGET: {
          var dataWidget = await this.loadDataWidget(this.itemLayer);
          this.itemLayer.typeLayer = this.typeChooseLayer.WIDGET;
          this.itemLayer.itemWidget = dataWidget;
        }
      }
      return this.itemLayer;
    },
  },
  watch: {
    isShow(value) {
      if (!value) {
        this.$emit("update:show", value);
      }
    },
    "urlYoutubeInput.data.model": function (value) {
      if (value && value !== "") {
        if (this.urlYoutubeInput.data.validator.valid()) {
          this.itemLayer = { url: value };
          this.disableButton = false;
        } else {
          this.disableButton = true;
        }
      } else {
        this.disableButton = true;
      }
    },
  },
  destroyed() {},
};
</script>

<style scoped>
.layout-insert-item-column {
  text-align: center;
}

.selected {
  border: 2px solid #118bff;
}

.layout-insert-item-type {
  border-radius: 3px;
  width: 100%;
  height: 140px;
  background: #dcdcdc;
  color: #fff;
  cursor: pointer;
  transition: all ease-in-out 0.2s;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 5px 0px #adb5bd;
}

.layout-insert-item-type img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.layout-insert-item-type.selected ~ .layout-insert-item-label {
  color: #6458ff;
  font-weight: bold;
}

.layout-insert-item-label {
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}
</style>
<style lang="scss">
#form-slideshow-add {
  .nav-link {
    padding: 0.8rem 1rem;
  }

  .folder-local-files {
    width: 100%;
    height: 120px;
    box-shadow: 0 0 5px 0 #adb5bd;

    img {
      width: 100%;
      height: 100%;
    }
  }

  tr {
    cursor: pointer;
  }
}
</style>
